// The SPA: five routes, one session provider, one theme provider.
//
// This is what `app/layout.tsx` was, minus the parts that were Next's. The
// `<html lang="ja">` and `<body className="bg-paper font-jp-body text-ink">`
// it rendered are in ../index.html and ../index.css now — a Vite SPA does not
// render its own document — and the five `next/font/google` families it
// composed onto the html element are @font-face declarations and CSS variables
// in the stylesheet instead. What survives is the ThemeProvider, unchanged
// down to the `d` hotkey.
//
// Routing is react-router, in the data-less mode every shipped app in this
// workspace uses. `/read/:id` and `/atlas/:level` read their params with
// `useParams`, which is what `params: Promise<{ id: string }>` becomes when
// there is no server to await.

import { BrowserRouter, Route, Routes } from "react-router";
import { ThemeProvider } from "./components/theme-provider";
import { SessionProvider } from "./hooks/use-session";
import { AtlasPage } from "./pages/atlas";
import { DrillPage } from "./pages/drill";
import { LandingPage } from "./pages/landing";
import { N5Page } from "./pages/n5";
import { ReadPage } from "./pages/read";

export function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <SessionProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/drill" element={<DrillPage />} />
            <Route path="/n5" element={<N5Page />} />
            <Route path="/atlas/:level" element={<AtlasPage />} />
            <Route path="/read/:id" element={<ReadPage />} />
          </Routes>
        </SessionProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
